import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  DateInput as AriaDateInput,
  DateInputProps,
} from "react-aria-components";

export function _DateInput(props: DateInputProps) {
  const className = css(styles.dateInput);

  return <AriaDateInput {...mergeProps(props, { className })} />;
}

const styles = {
  dateInput: css({ display: "flex", gap: "var(--space-2)" }),
};
